var _rect, _g, _g2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookhoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#FBF9F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 481.5 153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 153,
    width: 225,
    height: 635,
    rx: 18,
    ry: 18,
    fill: "#8B2D1F"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.5,
    y1: 365,
    x2: 481.5,
    y2: 365,
    stroke: "#1A1815",
    strokeOpacity: 0.08,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.5,
    y1: 576,
    x2: 481.5,
    y2: 576,
    stroke: "#1A1815",
    strokeOpacity: 0.08,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 542.5 153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.5,
    y: 153,
    width: 225,
    height: 635,
    rx: 18,
    ry: 18,
    fill: "#8B2D1F"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 542.5,
    y1: 365,
    x2: 767.5,
    y2: 365,
    stroke: "#1A1815",
    strokeOpacity: 0.08,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 542.5,
    y1: 576,
    x2: 767.5,
    y2: 576,
    stroke: "#1A1815",
    strokeOpacity: 0.08,
    strokeWidth: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 118,
    r: 20,
    fill: "#A8762B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookhoodIcon);
export default __webpack_public_path__ + "static/media/bookhood-icon.5b329a965f83779495f6a71e63df39f2.svg";
export { ForwardRef as ReactComponent };